import React from "react";

import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Background from "../../../components/Background";
import Placeholder from "../../../assets/image/notfoundbg.jpeg"

import style from "./style.module.css";

export default function Card({ item, size = "col5", type = "" }) {
    let image = item.thumbnail_image !== undefined && item.thumbnail_image !== null ? item.thumbnail_image : Placeholder;
    if (item.url !== "") {
        return (
            <Link to={`/${type}/${item.url}`} className={`${style.postCard} ${style[size]} ${style[item.media_type]}`}>
                <div className={style.postCardInner}>
                    <div className={style.imageWrap}>
                        {
                            image !== "" && (
                                <Background className={style.cardImage} src={image} size="520x520" cPosition="topLeft" />
                            )
                        }
                    </div>
                    <div className={style.textContent}>
                        <Title className="cardTitle" align="center" tag="h6">{item.name}</Title>
                    </div>
                </div>
            </Link>
        )
    }
}